import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import { useDeliveryStatusByMark } from '../../api/hooks/delivery/useDeliveryStatusByMark';
import { RectangleCard } from '../../components';
import { Loading } from '../../components/atoms/Loading';
import { STANDALONE_FEATURE } from '../../interfaces/enumerables';
import { PATHS } from '../../navigation/data';
import { useHasActiveFeature } from '../../services/utils/useHasActiveFeature';
import { DeliveryDocDetails } from './component/DeliveryDocDetails';
import { DeliveryInstructionsLink } from './component/DeliveryInstructionsLink';
import { DeliveryRetrieveDocByMark } from './component/DeliveryRetrieveDocByMark';

export const DeliveryOptionScreen = () => {
  const { isChecking: isFeatureChecking } = useHasActiveFeature(STANDALONE_FEATURE.TRANSIT, true);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mark } = useParams<{ mark: string }>();
  const [searchMark, setSearchMark] = useState<string | undefined>(mark || '');
  const handleSearch = useCallback(
    (m: string) => {
      setSearchMark(m);
      navigate(`${PATHS.DELIVERIES}/${m}`, { replace: true });
    },
    [navigate],
  );
  const { data, isLoading, isRefetching } = useDeliveryStatusByMark(searchMark);

  const getLoading = useCallback(() => {
    if (isLoading || isRefetching || isFeatureChecking) {
      return <Loading backgroundFull />;
    }
    return null;
  }, [isFeatureChecking, isLoading, isRefetching]);

  const getDocDetails = useCallback(() => {
    if (data && !isLoading) return <DeliveryDocDetails docData={data} />;
  }, [data, isLoading]);

  return (
    <>
      {getLoading()}
      <div className="scrollable width-100 flex-start-center-column-nowrap p-t-16 p-b-16 p-r-24 p-l-24">
        <DeliveryInstructionsLink />
        <div className="m-b-16 flex-center-center-column-nowrap width-100">
          <DeliveryRetrieveDocByMark onSearch={handleSearch} />
        </div>
        {getDocDetails()}
        <div className="flex-center-center-column-nowrap">
          <div className="flex-center-center-row-wrap gap-12">
            <RectangleCard
              label={t('DELIVERY.NEW_DELIVERY_RECTANGLE')}
              onPress={() => navigate(`${PATHS.DELIVERIES}/register-transfer/create`)}
            />
            <RectangleCard
              label={t('DELIVERY.RECEIVE_BUTTON')}
              onPress={() =>
                navigate(`${PATHS.DELIVERIES}/confirm-outcome/create`, {
                  state: { title: 'DELIVERY.CONFIRM_RECEIVE_TITLE' },
                })
              }
            />
            <RectangleCard
              label={t('DELIVERY.CONFIRM_DELIVERY_RECTANGLE')}
              onPress={() => navigate(`${PATHS.DELIVERIES}/confirm-outcome/create`)}
            />
            <RectangleCard
              label={t('DELIVERY.REJECT_DELIVERY_RECTANGLE')}
              onPress={() => navigate(`${PATHS.DELIVERIES}/reject-delivery/create`)}
            />
            <RectangleCard
              label={t('DELIVERY.CONFIRM_RETURN_RECTANGLE')}
              onPress={() => navigate(`${PATHS.DELIVERIES}/confirm-return/create`)}
            />
            <RectangleCard
              label={t('DELIVERY.NEW_SELF_DELIVERY_RECTANGLE')}
              onPress={() => navigate(`${PATHS.DELIVERIES}/new`)}
            />
            {/*<RectangleCard label={t('DELIVERY.ALL_DELIVERIES_RECTANGLE')} onPress={() => navigate(PATHS.DELIVERIES)} />*/}
          </div>
        </div>
      </div>
    </>
  );
};
